/* custom-stoel-v2-basis.js — het gedrag van de stoelen-PDP v2 (Pro / Premium / Elite).
 *
 * HERKOMST (herstructurering 2026-08-14): dit is custom-stoel.js — dat op zijn
 * beurt pdp.js uit het goedgekeurde designpakket is — met ÉÉN structurele
 * aanpassing: de v2-pagina bestaat sinds de opdeling uit veertien losse
 * secties met elk een eigen .stoel-pdp-wrapper, dus alles wat vroeger binnen
 * dé ene wortel zocht, zoekt nu over álle wortels. custom-stoel.js zelf blijft
 * ongewijzigd voor de v1-pagina's (kader 1: nooit aanraken); alleen de
 * v2-koopbloksectie laadt dít bestand. Gedrag is verder identiek.
 *
 * HERKOMST: dit is pdp.js uit het goedgekeurde designpakket, met drie soorten
 * wijzigingen voor de echte winkel:
 *   1. de winkelwagen is echt (POST /cart/add.js) in plaats van een preview-toast;
 *   2. de zittingkeuze wisselt de Shopify-VARIANT, niet alleen een bedrag;
 *   3. alles is gescoped op de .stoel-pdp-wortel zodat het niets van de
 *      Symmetry-theme aanraakt (header, footer, quickbuy).
 * De rest — galerij, reveals, ankernav, accordeon, keuzehulp, configurator,
 * sticky balk, leverdatum — is functioneel gelijk aan het ontwerp.
 *
 * Na een geslaagde toevoeging vuren we 'on:cart:change'. Dat is het event waar
 * Symmetry zelf op luistert om het aantal in de headerbubbel te verversen.
 */
(function () {
  'use strict';
  var doc = document;
  doc.documentElement.classList.add('js');

  var roots = Array.prototype.slice.call(doc.querySelectorAll('.stoel-pdp'));
  if (!roots.length) return;
  var root = roots[0]; /* het koopblok — eerste sectie in de DOM */
  /* vangnet voor browsers zonder :has() — hoort bij de uitbraak-CSS in de sectie */
  doc.body.classList.add('stoel-pdp-pagina');

  /* Hoofdcontract = het koopblok (eerste .stoel-pdp-data); losse banden mogen
     aanvullende accessoires uitzenden (de cross-sell-sectie doet dat). */
  var dataEls = Array.prototype.slice.call(doc.querySelectorAll('.stoel-pdp-data'));
  var DATA = {};
  try { DATA = dataEls[0] ? JSON.parse(dataEls[0].textContent) : {}; } catch (e) { DATA = {}; }
  for (var di = 1; di < dataEls.length; di++) {
    try {
      var extraData = JSON.parse(dataEls[di].textContent);
      if (extraData && extraData.accessoires) DATA.accessoires = (DATA.accessoires || []).concat(extraData.accessoires);
    } catch (e) { /* een kapot extra contract mag het hoofdcontract niet breken */ }
  }
  var M = DATA.model || {};
  var ROUTES = DATA.routes || { cartAdd: '/cart/add', cart: '/cart' };

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function smooth() { return reduced.matches ? 'auto' : 'smooth'; }
  function $(s, r) {
    if (r) return r.querySelector(s);
    for (var ri = 0; ri < roots.length; ri++) {
      var m = roots[ri].querySelector(s);
      if (m) return m;
    }
    return null;
  }
  function $$(s, r) {
    if (r) return Array.prototype.slice.call(r.querySelectorAll(s));
    var uit = [];
    for (var ri = 0; ri < roots.length; ri++) uit.push.apply(uit, roots[ri].querySelectorAll(s));
    return uit;
  }
  function euro(c) {
    return '€' + (c / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function euroKort(c) {
    /* r11: de bespaar-pill toont hele euro's zonder ,00 (Desktronic-notatie, Jory
       15-08); met centen valt hij terug op de volledige notatie. Alleen de pill —
       prijzen houden hun decimalen. */
    return c % 100 === 0 ? '€' + (c / 100).toLocaleString('nl-NL', { maximumFractionDigits: 0 }) : euro(c);
  }

  /* ---------- toast ---------- */
  var toastEl = $('[data-toast-node]');
  var toastT = null;
  function toast(msg, dur) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-in');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-in'); }, dur || 3400);
  }
  roots.forEach(function (rt) {
    rt.addEventListener('click', function (e) {
      var t = e.target.closest('[data-toast]');
      if (t && !t.closest('[data-xs-add]')) { toast(t.getAttribute('data-toast')); }
    });
  });

  /* ---------- winkelwagen (echt) ---------- */

  /* r2/W5 — de winkelwagenlade openen na een geslaagde toevoeging.
     Symmetry's eigen ProductForm sluit af met `.js-cart-drawer.open(knop)`
     (main.js:2814-2815). Dit koopblok onderschept de submit en doet een eigen
     fetch, dus die regel wordt nooit bereikt: de lade werd wél gevuld (via
     on:cart:change -> CartForm.refresh) maar nooit geopend — de bezoeker zag
     alleen het getal in de header oplopen.

     We wachten op 'on:cart:after-merge' (main.js:995, vuurt op de cart-form
     binnen de lade zodra de nieuwe inhoud erin staat), zodat de lade niet
     eerst leeg openklapt. Vangnet van 1200 ms voor het geval de merge uitblijft.

     Niet gebruiken: main.js:1000 vuurt 'theme:open-cart-drawer', maar in de
     hele codebase luistert daar niets naar — geverifieerd met een grep over
     assets/, sections/, snippets/ en layout/. */
  function ladeOpenen(opener) {
    if (!window.theme || !theme.settings) return;
    /* Bij cart_type 'page' rendert de lade helemaal niet (cart-drawer.liquid:1). */
    if (theme.settings.cartType !== 'drawer' || theme.settings.afterAddToCart !== 'drawer') return;
    var lade = doc.querySelector('.js-cart-drawer');
    if (!lade) return;
    var gedaan = false, timer = null;
    function open() {
      if (gedaan) return;
      gedaan = true; /* merge én vangnet mogen samen maar één keer openen */
      clearTimeout(timer);
      /* Staat de lade al open (tweede toevoeging zonder tussentijds sluiten), dan
         NIET opnieuw dispatchen. SideDrawer.open() maakt bij elke aanroep een verse
         `this.keyupHandler` en hangt die op het element (main.js:833-841), terwijl
         close() alleen de LAATSTE weer afhaalt (main.js:872-874) — elke extra open
         laat dus een wees-listener achter. Ook zouden 'before-open',
         theme.manuallyLoadImages en de cross-sell-init nodeloos opnieuw draaien.
         De inhoud is via on:cart:after-merge toch al ververst. */
      if (lade.hasAttribute('open')) return;
      doc.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
        bubbles: true, cancelable: false, detail: { opener: opener || null }
      }));
    }
    var vorm = lade.querySelector('cart-form');
    if (vorm) vorm.addEventListener('on:cart:after-merge', open, { once: true });
    timer = setTimeout(open, 1200);
  }

  var bezig = false;
  /* `geenLade` is de uitschakelaar per aanroeper. Hij staat nu nergens aan:
     Symmetry opent de lade zelf ook bij élke toevoeging, dus de accessoire-adds
     (regel ~534 en ~557) doen dat hier ook. Wil Jory dat accessoires stil
     toevoegen, dan is `true` als derde argument op die twee plekken genoeg. */
  function toevoegen(items, omschrijving, geenLade, opener) {
    if (bezig) return Promise.resolve();
    bezig = true;
    /* De knop is het focus-terugkeerdoel bij het sluiten van de lade. De aanroeper
       geeft hem expliciet mee; `activeElement` is alleen vangnet, want Safari
       (macOS én iOS) focust een <button> bij een klik niet. En na `dlg.close()`
       kan activeElement nog in de gesloten dialoog zitten — vandaar de toets of
       het element er nog echt is en bereikbaar is. */
    var knop = opener || (doc.activeElement && doc.activeElement !== doc.body ? doc.activeElement : null);
    if (knop && (!doc.contains(knop) || (knop.closest && (knop.closest('dialog:not([open])') || knop.closest('[inert]'))))) knop = null;
    roots.forEach(function (rt) { rt.classList.add('is-busy'); });
    return fetch(ROUTES.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.body && res.body.description ? res.body.description : 'Dit lukte niet. Probeer het nog een keer.');
          return;
        }
        toast(omschrijving + ' toegevoegd aan je winkelwagen.');
        /* Symmetry ververst zijn headerbubbel op dit event. */
        doc.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, detail: { cart: res.body } }));
        doc.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart: res.body } }));
        if (!geenLade) ladeOpenen(knop);
      })
      .catch(function () { toast('Dit lukte niet. Probeer het nog een keer.'); })
      .then(function () { bezig = false; roots.forEach(function (rt) { rt.classList.remove('is-busy'); }); });
  }

  /* ---------- reveals (IO + vangnetten) ---------- */
  (function () {
    var els = $$('.rv, .hero-orch');
    function alles() { els.forEach(function (el) { el.classList.add('is-in'); }); }
    if (reduced.matches || !('IntersectionObserver' in window)) { alles(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(alles, 2200); /* een pagina blijft nooit blanco */
  })();

  /* ---------- leverdatum (berekend, geen belofte die niet klopt) ---------- */
  (function () {
    var d = new Date(); d.setDate(d.getDate() + 1);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1); /* zondag -> maandag */
    var s = d.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' });
    $$('[data-leverdatum]').forEach(function (el) { el.textContent = s; });
  })();

  /* ---------- sleepbare rails (muis) ---------- */
  $$('[data-sleepbaar]').forEach(function (rail) {
    var down = false, moved = false, startX = 0, startL = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startL = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 6) { moved = true; rail.scrollLeft = startL - dx; }
    });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) {
      rail.addEventListener(ev, function () { down = false; });
    });
    rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });

  /* ---------- galerij ---------- */
  (function () {
    var gal = $('[data-gal]');
    if (!gal) return;
    var track = $('[data-gal-track]', gal);
    var slides = $$('.gal__slide', track);
    var thumbs = $$('[data-gal-thumb]', gal);
    var dots = $$('[data-gal-dot]', gal);
    var count = $('[data-gal-count]', gal);
    var galov = $('[data-galov]', gal);
    var cur = 0;
    function meet() {
      if (!galov) return;
      galov.style.setProperty('--galov-h', track.clientHeight + 'px');
    }
    meet();
    window.addEventListener('resize', meet);
    /* 21-08 pagespeed (A5): slides 2+ dragen hun echte bron in data-manual-src(set) —
       loading="lazy" hielp niet (horizontaal offscreen = binnen Chrome's drempel, 384 KB
       per mobiele lading). Swap bij de eerste galerij-interactie (goTo/scroll/pointerdown)
       of ná window.load, wat het eerst komt. Zelfde attribuutidioom als main.js r281. */
    var uitgesteldKlaar = false;
    function laadUitgesteld() {
      if (uitgesteldKlaar) return;
      uitgesteldKlaar = true;
      $$('img[data-manual-src]', track).forEach(function (img) {
        img.src = img.dataset.manualSrc;
        img.removeAttribute('data-manual-src');
        if (img.dataset.manualSrcset) {
          img.srcset = img.dataset.manualSrcset;
          img.removeAttribute('data-manual-srcset');
        }
      });
    }
    track.addEventListener('pointerdown', laadUitgesteld, { once: true, passive: true });
    track.addEventListener('touchstart', laadUitgesteld, { once: true, passive: true });
    if (document.readyState === 'complete') {
      setTimeout(laadUitgesteld, 0);
    } else {
      window.addEventListener('load', function () { setTimeout(laadUitgesteld, 0); }, { once: true });
    }
    function setCur(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (i === cur) return;
      cur = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-cur', n === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (galov) galov.classList.toggle('is-faded', i !== 0);
    }
    function goTo(i) {
      laadUitgesteld();
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth() });
      setCur(i);
    }
    var prev = $('[data-gal-prev]', gal), next = $('[data-gal-next]', gal);
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var raf = null;
    track.addEventListener('scroll', function () {
      laadUitgesteld(); /* wheel-/trackpadscroll komt binnen zonder pointerdown */
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft - track.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bd) { bd = d; best = i; }
        });
        setCur(best);
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur - 1); }
    });
  })();

  /* ---------- koopstaat: zitting, aantal, prijs, samenvatting (één bron) ---------- */
  var state = { seat: M.seats && M.seats.length ? M.seats[0].key : null, qty: 1 };
  function seatObj() {
    if (!M.seats) return null;
    for (var i = 0; i < M.seats.length; i++) if (M.seats[i].key === state.seat) return M.seats[i];
    return M.seats[0];
  }
  function unit() { var s = seatObj(); return s ? s.prijs : M.prijs; }
  function was() { var s = seatObj(); return (s ? s.was : M.was) || 0; }
  function variantNu() { var s = seatObj(); return s ? s.variantId : M.variantId; }
  function cfgTekst() {
    var s = seatObj();
    var delen = [M.naam];
    if (s) delen.push(s.naam);
    else if (M.vasteUitvoering) delen.push(M.vasteUitvoering);
    if (M.hoofdsteun) delen.push('met hoofdsteun');
    return delen.join(' · ');
  }
  /* r11: stabiel formulier-id, zodat de bestelknop in de closer-sectie
     (form="stoel-atc") sectie-overstijgend werkt. Terugval op het oude
     sectie-gebonden id voor de overgangsperiode. */
  var formEl = doc.getElementById('stoel-atc') || doc.getElementById('stoel-atc-' + DATA.sectie);
  function render() {
    var u = unit(), tot = u * state.qty, s = seatObj();
    $$('[data-price]').forEach(function (el) { el.textContent = euro(u); });
    $$('[data-price-excl]').forEach(function (el) { el.textContent = euro(Math.round(u / 1.21)); });
    $$('[data-atc-amt], [data-sticky-price]').forEach(function (el) { el.textContent = euro(tot); });
    $$('[data-ankernav-prijs]').forEach(function (el) { el.textContent = euro(u); });
    /* was-prijs en besparing volgen de gekozen variant: bij de Premium is dat 50 euro op
       mesh en 40 op schuim. Geen vergelijkprijs (of niet hoger) = blok verbergen, zodat er
       nooit een korting op het scherm staat die niet in Shopify staat. */
    var korting = was() > u ? was() - u : 0;
    $$('[data-price-compare]').forEach(function (el) {
      el.hidden = korting === 0;
      if (korting) el.textContent = euro(was());
    });
    $$('[data-price-save]').forEach(function (el) { el.hidden = korting === 0; });
    $$('[data-price-save-amt]').forEach(function (el) { if (korting) el.textContent = euroKort(korting); });
    /* 15-08 · desktop-stickybar: de was-prijs naast het prijs-totaal is óók een
       totaal (was × aantal), zodat het paar in de balk altijd klopt — data-sticky-price
       draagt daar immers u × qty. Zelfde regime: geen echte korting = verborgen. Het
       bedrag staat in een eigen amt-span zodat de sr-only-relatietekst ("in plaats
       van") blijft staan. De aantal-cue toont de basis van het totaal bij aantal >= 2. */
    $$('[data-sticky-was]').forEach(function (el) {
      el.hidden = korting === 0;
      var amt = el.querySelector('[data-sticky-was-amt]') || el;
      if (korting) amt.textContent = euro(was() * state.qty);
    });
    $$('[data-sticky-qty]').forEach(function (el) {
      el.hidden = state.qty < 2;
      el.textContent = state.qty < 2 ? '' : state.qty + ' stuks ·';
    });
    var calc = $('[data-price-calc]');
    if (calc) {
      calc.hidden = state.qty < 2;
      var l = $('[data-calc-l]', calc), r = $('[data-calc-r]', calc);
      if (l) l.textContent = state.qty + ' × ' + euro(u);
      if (r) r.textContent = euro(tot);
    }
    var sum = $('[data-cfgsum]');
    if (sum) sum.textContent = cfgTekst();
    var out = $('[data-qty-out]');
    if (out) out.textContent = String(state.qty);
    /* 15-08 · alleen bij échte zittingstaat (pre-r10-pad): sinds r10 is seats null en
       zijn de .seat2-tegels navigatie (v3-snippet, aria-current) — aria-pressed hoort
       niet op een div/a (axe critical aria-allowed-attr) en de oude vergelijking
       maakte het nog vreemder: null === null gaf overal 'true'. */
    if (M.seats) $$('.seat2').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-seat') === state.seat ? 'true' : 'false');
    });
    if (s && s.packshot) {
      var img = $('[data-model-packshot]');
      if (img && img.getAttribute('src') !== s.packshot) img.setAttribute('src', s.packshot);
    }
    /* het verborgen formulier volgt de staat, zodat de no-JS-POST ook klopt */
    if (formEl) {
      var vi = formEl.querySelector('[data-atc-variant]');
      var qi = formEl.querySelector('[data-atc-qty]');
      if (vi) vi.value = variantNu();
      if (qi) qi.value = state.qty;
    }
  }
  $$('.seat2').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-seat');
      if (!k || k === state.seat) return;
      state.seat = k;
      render(); /* alleen states en bedragen; focus blijft staan */
    });
  });
  $$('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.qty = Math.max(1, Math.min(9, state.qty + parseInt(b.getAttribute('data-qty'), 10)));
      render();
    });
  });

  function koop(opener) {
    var s = seatObj();
    var naam = M.naam + (s ? ' (' + s.naam + ')' : '');
    if (state.qty > 1) naam = state.qty + '× ' + naam;
    return toevoegen([{ id: variantNu(), quantity: state.qty }], naam, false, opener);
  }
  /* De koopknoppen zitten via het form-attribuut aan een verborgen formulier, zodat
     ze zonder JS gewoon posten. Met JS onderscheppen we de submit en doen we AJAX. */
  if (formEl) {
    /* e.submitter wijst ook naar knoppen buiten het form (form="stoel-atc"):
       zo krijgen koopkaart én closer-knop elk hun eigen focus-terugkeer. */
    formEl.addEventListener('submit', function (e) { e.preventDefault(); koop(e.submitter || null); });
  }
  render();

  /* ---------- sticky mobiele koopbalk ---------- */
  (function () {
    var bar = $('[data-sticky]');
    var koopblok = $('.byg--koop');
    if (!bar || !koopblok) return;
    bar.setAttribute('inert', '');
    function zet(aan) {
      bar.classList.toggle('is-in', aan);
      if (aan) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        zet(!e.isIntersecting && e.boundingClientRect.bottom < 0);
      }, { threshold: 0 }).observe(koopblok);
    } else { zet(true); }

    var scrim = $('.stickybar__scrim', bar), sheet = $('.sheet', bar);
    var cta = $('.stickybar__cta', bar);
    function sluitSheet() {
      if (!sheet) return;
      if (scrim) scrim.classList.remove('is-open');
      sheet.classList.remove('is-open');
      if (cta) cta.setAttribute('aria-expanded', 'false');
      sheet.setAttribute('aria-hidden', 'true');
      if (cta) cta.focus();
    }
    if (cta) {
      cta.addEventListener('click', function () {
        if (!sheet) { koop(cta); return; } /* Pro: geen zittingkeuze, direct toevoegen */
        var open = sheet.classList.toggle('is-open');
        if (scrim) scrim.classList.toggle('is-open', open);
        cta.setAttribute('aria-expanded', open ? 'true' : 'false');
        sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open) { var c = $('.sheet__close', sheet); if (c) c.focus(); }
      });
    }
    if (scrim) scrim.addEventListener('click', sluitSheet);
    if (sheet) {
      var sc = $('.sheet__close', sheet);
      if (sc) sc.addEventListener('click', sluitSheet);
      doc.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sheet.classList.contains('is-open')) sluitSheet();
      });
      var sa = $('[data-atc-sheet]', sheet);
      if (sa) sa.addEventListener('click', function () { setTimeout(sluitSheet, 50); });
    }
  })();

  /* ---------- ankernav (desktop): scrollspy ---------- */
  (function () {
    var nav = $('[data-ankernav]');
    if (!nav) return;
    var links = $$('a[href^="#sec-"]', nav).filter(function (a) { return a.closest('.ankernav__links'); });
    var secs = links.map(function (a) { return $(a.getAttribute('href')); }).filter(Boolean);
    if (!('IntersectionObserver' in window) || !secs.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        links.forEach(function (a) {
          a.setAttribute('aria-current', a.getAttribute('href') === '#' + en.target.id ? 'true' : 'false');
        });
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    secs.forEach(function (s) { io.observe(s); });
  })();

  /* ---------- bezwaren: pills + accordeon ---------- */
  $$('.faqpill').forEach(function (p) {
    p.addEventListener('click', function () {
      $$('.faqpill').forEach(function (x) { x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
      var acc = $('.acc--onderwerpen');
      if (acc) acc.setAttribute('data-active-topic', p.getAttribute('data-topic'));
    });
  });
  $$('.acc__btn').forEach(function (b) {
    b.addEventListener('click', function () {
      var it = b.closest('.acc__item'), open = it.classList.contains('is-open');
      b.setAttribute('aria-expanded', String(!open));
      it.classList.toggle('is-open', !open);
    });
  });

  /* ---------- vergelijkings-railhint (mobiel) ---------- */
  (function () {
    var rail = $('.mc-check');
    var hint = $('.railhint');
    if (!rail || !hint) return;
    var ds = $$('.railhint__d', hint);
    rail.addEventListener('scroll', function () {
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 0) return;
      var i = Math.min(ds.length - 1, Math.round((rail.scrollLeft / max) * (ds.length - 1)));
      ds.forEach(function (d, n) { d.classList.toggle('is-cur', n === i); });
    }, { passive: true });
  })();

  /* ---------- accessoire-popup: kiezen en toevoegen ---------- */
  (function () {
    var dlg = $('.stoel-dlg-xs');
    if (!dlg) return;
    var body = $('[data-xsd-body]', dlg);
    var opener = null, prod = null, gekozen = 0;
    var CHECK = '<svg class="ic" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10.2l4 4L16.2 6"></path></svg>';

    function varianten(p) { return (p.varianten || []).filter(function (v) { return v.beschikbaar !== false; }); }
    function variantNuAcc() {
      var vs = varianten(prod);
      return vs[gekozen] || vs[0] || null;
    }
    function prijsNu() {
      var v = variantNuAcc();
      return v ? v.prijs : prod.prijs;
    }
    function bouw() {
      var vs = varianten(prod);
      var h = '<button type="button" class="dlg__close" data-xsd-close aria-label="Sluiten">' +
        '<svg class="ic" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5.5 5.5l9 9M14.5 5.5l-9 9"></path></svg></button>' +
        '<div class="xsd__head"><img class="xsd__img" src="' + (prod.img || '') + '" alt="" width="84" height="84">' +
        '<div class="xsd__ht"><h2>' + prod.naam + '</h2><p class="xsd__intro">' + (prod.sub || '') + '</p></div></div>';
      if (prod.bullets && prod.bullets.length) {
        h += '<ul class="xsd__usps">' + prod.bullets.map(function (b) { return '<li>' + CHECK + '<span>' + b + '</span></li>'; }).join('') + '</ul>';
      }
      if (vs.length > 1) {
        h += '<div class="xsd__group"><span class="xsd__label" id="xsd-g0">Uitvoering</span><div class="xsd__opts" role="group" aria-labelledby="xsd-g0">';
        vs.forEach(function (v, i) {
          var isSel = gekozen === i;
          h += '<button type="button" class="xsd__opt' + (isSel ? ' is-sel' : '') + '" aria-pressed="' + isSel + '" data-keuze="' + i + '">' + v.naam +
            '<span class="xsd__optp">' + euro(v.prijs) + '</span></button>';
        });
        h += '</div></div>';
      }
      h += '<div class="xsd__acts"><button type="button" class="btn btn--primary" data-xsd-add>In winkelwagen, <span data-xsd-prijs>' + euro(prijsNu()) + '</span></button>';
      if (prod.url) h += '<a class="btn btn--ghost" href="' + prod.url + '">Bekijk de productpagina</a>';
      h += '</div>';
      body.innerHTML = h;
    }
    function open(key, op) {
      prod = (DATA.accessoires || []).filter(function (a) { return String(a.key) === String(key); })[0];
      if (!prod) return;
      opener = op || null;
      gekozen = 0;
      bouw();
      dlg.showModal();
    }
    roots.forEach(function (rt) {
      rt.addEventListener('click', function (e) {
        var t = e.target.closest('[data-xs-info]');
        if (t) { e.preventDefault(); open(t.getAttribute('data-xs-info'), t); return; }
        var kaart = e.target.closest('.buyupc');
        if (kaart && !e.target.closest('button,a')) {
          var b = kaart.querySelector('[data-xs-info]');
          if (b) open(b.getAttribute('data-xs-info'), b);
        }
      });
    });
    dlg.addEventListener('click', function (e) {
      var opt = e.target.closest('.xsd__opt');
      if (opt) {
        gekozen = parseInt(opt.getAttribute('data-keuze'), 10);
        $$('.xsd__opt', dlg).forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('is-sel', on);
          o.setAttribute('aria-pressed', String(on));
        });
        var pe = $('[data-xsd-prijs]', dlg);
        if (pe) pe.textContent = euro(prijsNu());
        return;
      }
      if (e.target.closest('[data-xsd-close]')) { dlg.close(); return; }
      var add = e.target.closest('[data-xsd-add]');
      if (add) {
        var v = variantNuAcc();
        dlg.close();
        if (v) toevoegen([{ id: v.variantId, quantity: 1 }], prod.naam + (varianten(prod).length > 1 ? ' (' + v.naam + ')' : ''), false, opener);
        return;
      }
      if (e.target === dlg) dlg.close();
    });
    dlg.addEventListener('close', function () { if (opener && doc.contains(opener)) opener.focus(); });
  })();

  /* ---------- cross-sell: + Toevoegen -> ✓ Toegevoegd ---------- */
  $$('[data-xs-add]').forEach(function (b) {
    var orig = b.innerHTML;
    b.addEventListener('click', function () {
      var p = (DATA.accessoires || []).filter(function (a) { return String(a.key) === String(b.getAttribute('data-xs-add')); })[0];
      if (!p) return;
      var vs = (p.varianten || []).filter(function (v) { return v.beschikbaar !== false; });
      if (vs.length > 1) {
        /* meerdere uitvoeringen: eerst laten kiezen in de popup */
        var info = b.parentNode.querySelector('[data-xs-info]');
        if (info) { info.click(); return; }
      }
      var v = vs[0];
      if (!v) return;
      b.innerHTML = '✓ Toegevoegd';
      toevoegen([{ id: v.variantId, quantity: 1 }], p.naam, false, b);
      setTimeout(function () { b.innerHTML = orig; }, 2600);
    });
  });

  /* ---------- keuzehulp (volledige beslisboom) ---------- */
  (function () {
    var dlg = $('.stoel-dlg-quiz');
    if (!dlg || !DATA.quiz || !DATA.quiz.vragen || !DATA.quiz.vragen.length) return;
    var body = $('[data-quiz-body]', dlg);
    var vragen = DATA.quiz.vragen;
    var opener = null, stap = 0, antw = [];
    var CHECK = '<svg class="ic" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10.2l4 4L16.2 6"></path></svg>';
    var CLOSE = '<button type="button" class="dlg__close" data-quiz-close aria-label="Sluiten">' +
      '<svg class="ic" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5.5 5.5l9 9M14.5 5.5l-9 9"></path></svg></button>';
    function vraagScherm() {
      var v = vragen[stap];
      var h = CLOSE + '<p class="quiz__prog">Vraag ' + (stap + 1) + ' van ' + vragen.length + '</p>' +
        '<h2 class="quiz__q">' + v.q + '</h2><div class="quiz__opts">';
      v.opts.forEach(function (o, i) {
        h += '<button type="button" data-quiz-antwoord="' + i + '">' + o.t + '</button>';
      });
      h += '</div><div class="quiz__nav">' +
        (stap > 0 ? '<button type="button" data-quiz-terug>Vorige vraag</button>' : '<span></span>') +
        '<button type="button" data-quiz-reset>Opnieuw beginnen</button></div>';
      body.innerHTML = h;
    }
    function uitkomst() {
      /* 1. eerlijk antwoord voor wie langer is dan 1,95 m */
      if (antw[2] === 2) {
        var tl = DATA.quiz.teLang || {};
        body.innerHTML = CLOSE + '<h2 class="quiz__q">' + (tl.kop || '') + '</h2><p>' + (tl.tekst || '') + '</p>' +
          '<p class="quiz__service">' + (tl.service || '') + ' <a href="mailto:' + (tl.mail || '') + '">' + (tl.mail || '') + '</a></p>' +
          '<div class="quiz__nav"><span></span><button type="button" data-quiz-reset>Opnieuw beginnen</button></div>';
        return;
      }
      /* 2. vraag 4 bepaalt het model; 3. twee correcties */
      var keys = ['pro', 'premium', 'elite'];
      var key = keys[antw[3]];
      if (antw[1] === 0 && key === 'pro') key = 'premium';   /* hoofdsteun gewenst, Pro heeft er geen */
      if (antw[2] === 1 && key === 'elite') key = 'premium'; /* 1,90-1,95 m, Elite gaat tot 1,90 m */
      var mod = (DATA.serie || {})[key];
      if (!mod) return;
      var redenen = [];
      if (antw[0] === 2 && key === 'elite') redenen.push('Gebouwd voor lange werkdagen');
      if (antw[1] === 0 && key !== 'pro') redenen.push('Met verstelbare hoofdsteun');
      var r4 = vragen[3] && vragen[3].opts[antw[3]] ? vragen[3].opts[antw[3]].reason : null;
      if (r4 && redenen.indexOf(r4) < 0) redenen.push(r4);
      var tip;
      if (key === 'pro') tip = 'De Pro heeft een vaste combinatie: mesh-rug met koudschuim-zitvlak.';
      else if (antw[4] === 0) tip = 'Tip: kies de mesh-zitting.';
      else if (antw[4] === 1) tip = 'Tip: kies de schuim-zitting.';
      else tip = 'Twijfel je over de zitting? Onze klantenservice denkt met je mee.';
      var actie;
      if (key === M.key) {
        actie = '<p class="quiz__tip">Dat is de stoel die je nu bekijkt.' + (M.seats ? ' Kies hieronder je uitvoering.' : '') + '</p>' +
          '<div class="quiz__acts"><button type="button" class="btn btn--primary" data-quiz-naar-keuze>Naar de keuze</button></div>';
      } else {
        actie = '<div class="quiz__acts"><a class="btn btn--primary" href="' + mod.url + '">Bekijk de ' + mod.naam + '</a></div>';
      }
      body.innerHTML = CLOSE + '<h2 class="quiz__q">Jouw match</h2>' +
        '<div class="quiz__match"><img src="' + mod.packshot + '" alt="' + mod.naam + ', vrijstaand productbeeld" width="88" height="88"><div><b>' + mod.naam + '</b><span>' + mod.prijsLabel + '</span></div></div>' +
        '<ul class="quiz__reasons">' + redenen.map(function (r) { return '<li>' + CHECK + '<span>' + r + '</span></li>'; }).join('') + '</ul>' +
        '<p class="quiz__tip">' + tip + '</p>' + actie +
        '<div class="quiz__nav"><span></span><button type="button" data-quiz-reset>Opnieuw beginnen</button></div>';
    }
    function open(op) {
      opener = op || null;
      stap = 0; antw = []; /* elke opening begint bij vraag 1, leeg */
      vraagScherm();
      dlg.showModal();
    }
    roots.forEach(function (rt) {
      rt.addEventListener('click', function (e) {
        var t = e.target.closest('[data-quiz-open]');
        if (t) { e.preventDefault(); open(t); }
      });
    });
    dlg.addEventListener('click', function (e) {
      var a = e.target.closest('[data-quiz-antwoord]');
      if (a) {
        antw[stap] = parseInt(a.getAttribute('data-quiz-antwoord'), 10);
        stap += 1;
        if (stap >= vragen.length) uitkomst(); else vraagScherm();
        return;
      }
      if (e.target.closest('[data-quiz-terug]')) { stap = Math.max(0, stap - 1); vraagScherm(); return; }
      if (e.target.closest('[data-quiz-reset]')) { stap = 0; antw = []; vraagScherm(); return; }
      if (e.target.closest('[data-quiz-close]')) { dlg.close(); return; }
      if (e.target.closest('[data-quiz-naar-keuze]')) {
        dlg.close();
        var doel = $('.byg--kzseat') || $('.byg--koop');
        if (doel) {
          var y = doel.getBoundingClientRect().top + window.pageYOffset - 84;
          window.scrollTo({ top: y, behavior: smooth() });
        }
        return;
      }
      if (e.target === dlg) dlg.close();
    });
    dlg.addEventListener('close', function () { if (opener && doc.contains(opener)) opener.focus(); });
  })();

  /* ---------- video-slide in de galerij ---------- */
  $$('.gal__slide--video').forEach(function (s) {
    s.addEventListener('click', function () {
      toast('De video volgt. De still is nu nog een voorbeeld.');
    });
  });
})();
